import { createTheme } from "@mui/material/styles";
import componentStyleOverrides, {
  getReusableComponentStyles,
} from "./compStyleOverride";
import themePalette from "./palette";
import themeTypography from "./typography";
import colors from "./_themes-vars.module.scss";
import { borderRadius } from "./constant";

/**
 * @param {"light" | "dark"} mode
 */
export function createAppTheme(mode) {
  try {
    const color = colors;
    const isDark = mode === "dark";

    const themeOption = {
      colors: color,
      mode,
      heading: isDark ? color.darkTextTitle : color.grey900,
      paper: isDark ? color.darkPaper : color.paper,
      // Light: off-white canvas so white Papers read as elevated cards (better than white-on-white).
      backgroundDefault: isDark ? color.darkBackground : color.grey50,
      background: isDark ? color.darkBackground : color.brandPrimaryLight,
      darkTextPrimary: isDark ? color.darkTextPrimary : color.grey700,
      darkTextSecondary: isDark ? color.darkTextSecondary : color.grey500,
      textDark: isDark ? color.darkTextPrimary : color.grey900,
      menuSelected: isDark ? color.darkTextPrimary : color.grey900,
      menuSelectedBack: isDark ? color.darkLevel1 : color.brandPrimaryMain,
      divider: isDark ? color.darkLevel1 : color.grey200,
      customization: {
        navType: mode,
        borderRadius: borderRadius,
      },
    };

    const themeOptions = {
      direction: "ltr",
      palette: {
        ...themePalette(themeOption),
        mode,
      },
      mixins: {
        toolbar: {
          minHeight: "48px",
          padding: "16px",
          "@media (min-width: 600px)": {
            minHeight: "48px",
          },
        },
      },
      typography: {
        htmlFontSize: 18,
        ...themeTypography(themeOption),
      },
      components: componentStyleOverrides(themeOption),
      custom: {
        borderRadius: borderRadius,
        componentStyles: getReusableComponentStyles(themeOption),
        shadows: {
          xs: "0 1px 2px rgba(0, 0, 0, 0.05)",
          sm: "0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06)",
          md: "0 4px 6px rgba(0, 0, 0, 0.07), 0 2px 4px rgba(0, 0, 0, 0.06)",
          lg: "0 10px 15px rgba(0, 0, 0, 0.1), 0 4px 6px rgba(0, 0, 0, 0.05)",
          xl: "0 20px 25px rgba(0, 0, 0, 0.1), 0 10px 10px rgba(0, 0, 0, 0.04)",
        },
      },
    };

    return createTheme(themeOptions);
  } catch (error) {
    console.error("Failed to create theme:", error);
    return createTheme({
      palette: {
        mode: "light",
      },
    });
  }
}
